module.exports = __webpack_public_path__ + "static/media/bookagain.4dc3d743.svg";